style= require('./esports-information.styl')
.events
  if leagues && leagues.length
    .leagues
      each league in leagues
        .league((click)=this.selectLeague(league), class= league == selectedLeague  ? 'selected' : '')
          .name
            = league.name
          .leagueId
            = `League ID: ${league.leagueid}`
          a.link(href=league.tournament_url, target="_blank")
            = 'Tournament webpage'
    .matches
      if selectedLeague && liveMatches && liveMatches.length >= 1
        .selectedLeague
          .name
            =selectedLeague.name
          .leagueId
            =selectedLeague.id
        .live-matches
          each match in liveMatches
            .match
              .series-id
                match.
              .match-id
                = 'Match ID: '
                = match.match_id
              .teams
                .homeTeam
                  .series-stats
                    = 'Score '
                    = match.radiant_series_wins
                  .name

                    = match.radiant_team.team_name
                  .teamId
                    = 'Team ID '
                    = match.radiant_team.team_id
                .awayTeam
                  .series-stats
                    = 'Score '
                    = match.dire_series_wins
                  .name
                    = match.dire_team.team_name
                  .teamId
                    = 'Team ID '
                    = match.dire_team.team_id
                    
      else
        .empty
            = 'No matches available right now, check later.'    
